<template>
    <div class="flex flex-column justify-content-center align-items-center w-full h-full md:p-4">
        <span class="H6-Medium pb-4">Set my availability</span>
        <div class="grid w-full align-items-start justify-content-center">
            <!-- Left Card - Form -->
            <div class="col-12 md:col-6">
                <div class="card p-3">
                    <Form @submit="handleRegister" :initialValues="initialValues" :resolver="resolver" class=" form">
                        <span class="Paragraph-Medium py-2">Set my availability</span>
                        <div class="grid w-full align-items-center justify-content-center  ">
                            <div class="col-12">
                                <div class="flex flex-column gap-3 pt-4">
                                    <label for="date" class="Label align-self-start">Date</label>
                                    <IconField class="w-full">
                                        <DatePicker v-model="date" placeholder="Select date here" dateFormat="dd/mm/yy"
                                            showIcon fluid iconDisplay="input" variant="filled" size="small"
                                            class="w-full" />
                                    </IconField>
                                </div>
                            </div>
                            <div class="col-12 md:col-6">
                                <div class="flex flex-column gap-3 pt-4">
                                    <label for="startTime" class="Label align-self-start">Start Time</label>
                                    <DatePicker v-model="startTime" showIcon variant="filled" fluid size="small"
                                        class="w-full" iconDisplay="input" timeOnly>
                                        <template #inputicon="slotProps">
                                            <i class="pi pi-clock" @click="slotProps.clickCallback" />
                                        </template>
                                    </DatePicker>
                                </div>
                            </div>
                            <div class="col-12 md:col-6">
                                <div class="flex flex-column gap-3 pt-4">
                                    <label for="endTime" class="Label align-self-start">End Time</label>
                                    <DatePicker v-model="endTime" showIcon variant="filled" fluid size="small"
                                        class="w-full" iconDisplay="input" timeOnly>
                                        <template #inputicon="slotProps">
                                            <i class="pi pi-clock" @click="slotProps.clickCallback" />
                                        </template>
                                    </DatePicker>
                                </div>
                            </div>
                            <div class="col-12 col-6  flex flex-column  gap-3">
                                <label for="Note" class="Label align-self-start">Note</label>
                                <IconField class="w-full w-full flex align-items-start">
                                    <InputIcon class="pi pi-file " />
                                    <Textarea v-model="note" variant="filled" autoResize rows="5" cols="30"
                                        class="w-full" />
                                </IconField>
                            </div>
                            <div class="col-12 col-6 flex justify-content-start">
                                <div class="flex flex-wrap align-items-center gap-3 ">
                                    <Button label="Set Availability" class="teal-button-small mt-6"
                                        @click="AddAvailability" />
                                    <Button label="cancel" class="teal-button-transparent-small mt-6" @click="cancel" />
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>

            <!-- Right Card - DataTable -->
            <div class="col-12 md:col-6">
                <div class="card p-3">
                    <span class="Paragraph-Medium py-2">Availability List</span>
                    <DataTable :value="availabilityList" class="p-datatable-sm">
                        <Column header="Date">
                            <template #body="slotProps">
                                {{ formatDateOnly(slotProps.data.date) }}
                            </template>
                        </Column>

                        <Column header="Start Time">
                            <template #body="slotProps">
                                {{ formatTimeOnly(slotProps.data.start) }}
                            </template>
                        </Column>

                        <Column header="End Time">
                            <template #body="slotProps">
                                {{ formatTimeOnly(slotProps.data.end) }}
                            </template>
                        </Column>
                        <Column field="note" header="Note"></Column>
                        <Column header="Actions">
                            <template #body="slotProps">
                                <Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm"
                                    severity="danger" @click="deleteAvailability(slotProps.index)" />
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Button from "primevue/button";
import { defineEmits, ref, computed, defineProps } from "vue";
import { Form } from "@primevue/forms";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import Textarea from 'primevue/textarea';
import DatePicker from 'primevue/datepicker';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

const props = defineProps({
    availabilityList: { type: Array, required: true }
});
const availabilityList = computed(() => props.availabilityList);
const emit = defineEmits(['cancel', 'add-availability', 'delete-availability']);
const cancel = () => emit('cancel');

const date = ref('');
const startTime = ref('');
const endTime = ref('');
const note = ref('');

const deleteAvailability = (index) => {
    const slot = availabilityList.value[index];
    emit("delete-availability", slot._id);
};

const AddAvailability = () => {
    if (date.value && startTime.value && endTime.value) {
        emit("add-availability", {
            date: date.value,
            start: startTime.value,
            end: endTime.value,
            note: note.value || ""
        });

        date.value = "";
        startTime.value = "";
        endTime.value = "";
        note.value = "";
    }
};

const formatDateOnly = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split("T")[0]; // 2025-11-24
};

const formatTimeOnly = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false, // 24h format; change to true for AM/PM
    });
};
</script>

<style scoped>
.form {
    width: 100%;
}

.card {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: white;
}
</style>